module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n\t\tTags.1\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('NbTag', {
    attrs: {
      "tags": _vm.tags
    },
    on: {
      "tags-change": _vm.handleChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.tags) + "\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-31d369f6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/wheel/NbTagDemo.vue
// module id = 967
// module chunks = 1